import axios from 'axios';
import BaseAPI from './base/base-api';

class dashboardAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'ManagementAPI';
    controllerName = 'dashboard';
}

export default new dashboardAPI();